import React from 'react';
import { connect } from 'react-redux';
import { Button, Table } from 'semantic-ui-react';
import { each, find, flatten, map, union } from 'lodash';
import { translate } from 'react-i18next';
import PhotoBoothModal from '../../../../../../../containers/PhotoBoothModal';
import { closeAllModals } from '../../../data/fileImport/modalActions';

const SessionMessages = props => {
  return (
    <PhotoBoothModal {...props}>
      <div className="sessionMessage__container">
        <h3 className="modal-title">Messages</h3>
        <div className="sessionMessage__table-container">
          <Table celled className="sessionMessage__table table striped">
            <Table.Body>
              {props.messages.map((message, i) => {
                const messageParameters = message[`${message.type}_error_parameters`].reduce(
                  (params, obj) => {
                    params[obj.error_parameter.name] = obj.value;
                    return params;
                  },
                  {}
                );
                return (
                  <Table.Row key={i}>
                    <Table.Cell>{props.t(message.error.error_key, messageParameters)}</Table.Cell>
                  </Table.Row>
                );
              })}
            </Table.Body>
          </Table>
        </div>
        <div className="submit-btn-container">
          <Button
            className="green right floated"
            type="button"
            onClick={event => props.dispatch(closeAllModals())}
          >
            <i className="check square outline icon" /> OK
          </Button>
        </div>
      </div>
    </PhotoBoothModal>
  );
};

export default connect((state, props) => {
  let dataTree;

  dataTree = find(state.projects.single.fileImport.dataTrees, { id: props.resourceId });

  let dataTreeMessages = [];
  if (dataTree) {
    const node_operation_message_types = ['node_validation', 'node_sync', 'node_transformation'];
    each(dataTree.data_tree_nodes, (dataTreeNode, key) => {

      each(node_operation_message_types, (operation, key) => {
        if (operation === 'node_transformation') {

          if (dataTreeNode.data_tree_node_transformation && dataTreeNode.data_tree_node_transformation.node_transformation_errors) {

           const errorMessages = map(dataTreeNode.data_tree_node_transformation.node_transformation_errors, message => {
             return { ...message, type: operation };
           });
           console.log("errorMessages",errorMessages)
            console.log("dataTreeMessages",dataTreeMessages)
            dataTreeMessages = flatten(union(dataTreeMessages, errorMessages));
            console.log("dataTreeMessagesafter",dataTreeMessages)
         }
        } else  if (dataTreeNode[operation] && dataTreeNode[operation][`${operation}_errors`]) {
          const errorMessages = map(dataTreeNode[operation][`${operation}_errors`], message => {
            return { ...message, type: operation };
          });
          dataTreeMessages = flatten(union(dataTreeMessages, errorMessages));
        }
      });
    });
  }

  return {
    dataTree,
    messages: dataTreeMessages
  };
})(translate()(SessionMessages));



// WEBPACK FOOTER //
// ./src/scenes/projects/scenes/singleProject/components/fileImport/modals/SessionMessages.js